import React from "react";
import {
  Paper,
  Button,
  TextField,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Divider,
  Checkbox,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog } from "../include";
import _ from "underscore";

class NewPermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "",
      name: "",
      description: "",
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { category, name, description } = this.state;
    if (!category || !name || !description) {
      this.props.alert("Preencha todos os campos");
    } else {
      this.props.api
        .post("/Permissions", { category, name, description })
        .then((r) => {
          this.props.dialogClose();
          this.props.alert(r.message);
        })
        .catch(() => this.props.alert("Ocorreu um erro ao criar a permissão"));
    }
  };

  render() {
    const { category, name, description } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle>Nova permissão de acesso</DialogTitle>
        <DialogContent>
          <TextField
            value={category}
            onChange={(e) => this.setState({ category: e.target.value })}
            type="text"
            name="category"
            label="Categoria"
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
          <TextField
            value={name}
            onChange={(e) => this.setState({ name: e.target.value })}
            type="text"
            name="name"
            label="Nome"
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
          <TextField
            rows={5}
            value={description}
            onChange={(e) => this.setState({ description: e.target.value })}
            type="text"
            name="description"
            label="Descrição"
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => this.props.dialogClose()}
          >
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Permissions extends React.Component {
  constructor(props) {
    super(props);
    this.updateData = this.updateData.bind(this);
    this.state = {
      searchField: "",
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === "w"
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: "id", headerName: "ID", width: 70 },
      { field: "category", headerName: "Categoria", flex: 1 },
      { field: "name", headerName: "Nome", flex: 1 },
      { field: "description", headerName: "Descrição", flex: 2 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData(page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) {
    this.setState({ loading: true });
    this.props.api
      .get("/Permissions", { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.permissions || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handleSearch = () => {
    // Call updateData with the current searchField to trigger the backend search
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.indexOf(i) > -1 ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };

  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: "5px" }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length > 0 && (
                <>
                  {this.props.permission === "w" && (
                    <Tooltip title="Excluir selecionados" arrow>
                      <IconButton
                        onClick={() =>
                          this.props.dialog(
                            <ConfirmDialog
                              title="Excluir Itens"
                              msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                              reg={
                                this.state.selectedRows.length > 1
                                  ? this.state.selectedRows.length + " registros selecionados"
                                  : "1 registro selecionado"
                              }
                              onCancel={this.props.dialogClose}
                              onConfirm={() => {
                                for (var i in this.state.selectedRows) {
                                  var id = this.state.selectedRows[i].id;
                                  this.props.api
                                    .delete("/Permission/" + id)
                                    .then((r) => {
                                      this.props.alert(r.message);
                                      this.props.dialogClose();
                                      this.setState({ selectedRows: [] });
                                      this.updateData();
                                    })
                                    .catch((e) =>
                                      this.props.alert("Ocorreu um erro ao excluir o registro")
                                    );
                                }
                              }}
                            />
                          )
                        }
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  )}
                  <D size="0.5rem" />
                </>
              )}

              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: "12px" }}
                  onClick={() =>
                    this.props.dialog(
                      <NewPermission
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: "100%", height: "800px", overflow: "hidden" }}>
          <DataGrid
            rows={dataTable || []}
            columns={this.columns || []}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
